<template>
  <div class="page-content">
    <div class="is-flex" :class="{'flex-dir-col': !isDesktop}">
      <div class="left-box">
        <div :class="{'margin-bottom-61':isDesktop, 'margin-bottom-30':isTablet, 'margin-bottom-19':isMobile}">
          <div class="lb_head">
            <span class="has-text-weight-semibold">Review of</span>
            <router-link :to="{ name: 'BusinessDetail', params: { slug: business } }" class="link--v2">{{ bizname }}</router-link>
          </div>
          <biz-performance :industries="industryRankSorted" v-if="!isDesktop" class="biz-perf"/>
          <template v-if="!isMobileAds">
            <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
            <p class="has-text-centered">
              <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
            </p>
          </template>
          <template v-else>
            <p class="has-text-centered">
              <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad>
            </p>
          </template>
          <loader v-if="fetching_data"/>
          <review-card-v2 v-else-if="reviewDetail" v-bind:review.sync="reviewDetail" v-bind:messages.sync="reviewDetail.messages" :messagesCount="reviewDetail.messages.length" :itemProps="true"
                          :class="{'margin-left-11': isTablet, 'margin-right-36': isTablet}"/>
        </div>

        <div :class="{'margin-bottom-28': isDesktop, 'margin-bottom-26': isTablet,'font-size-12': isMobile, 'margin-bottom-18': isMobile}" v-if="sameBizReviews.reviews.length || sameIndusReviews.reviews.length">
          <div v-if="sameBizReviews.reviews.length">
            <div :class="{'margin-bottom-45': isDesktop, 'margin-bottom-34': isTablet, 'margin-left-14': isTablet, 'margin-left-15': isMobile, 'margin-bottom-26': isMobile}">
              <span :class="{'has-text-weight-semibold': !isMobile}">Other reviews from</span>
              <router-link :to="{ name: 'BusinessDetail', params: { slug: business } }" class="link--v2">{{ bizname }}</router-link>
            </div>
            <VueSlickCarousel :variableWidth="true" :slidesToShow="1" :slidesToScroll="1" :infinite="true" :arrows="isDesktop">
              <biz-other-review-card v-for="(review, key) in sameBizReviews.reviews" :key="key" :review="review"/>
              <template #prevArrow="arrowOption">
                <carousel-arrow dir="left"/>
              </template>
              <template #nextArrow="arrowOption">
                <carousel-arrow dir="right"/>
              </template>
            </VueSlickCarousel>
          </div>
          <div class="separator" v-if="sameBizReviews.reviews.length && sameIndusReviews.reviews.length"></div>
          <div v-if="sameIndusReviews.reviews.length">
            <div :class="{'margin-bottom-34': isTablet, 'margin-bottom-39': isDesktop, 'margin-left-15': isMobile, 'margin-bottom-18': isMobile}">
              <span :class="{'has-text-weight-semibold': !isMobile}">Reviews from other</span>
              <router-link :to="{ name: 'Industries-Category', params: { slug: sameIndusReviews.indusSlug } }" class="link--v2">{{ sameIndusReviews.indusName }}</router-link>
              <span :class="{'has-text-weight-semibold': !isMobile}">&nbsp;businesses</span>
            </div>
            <VueSlickCarousel :variableWidth="true" :slidesToShow="1" :slidesToScroll="1" :infinite="true" :arrows="isDesktop">
              <biz-review-card v-for="(review, key) in sameIndusReviews.reviews" :key="key" :review="review" :miniView="true"/>
              <template #prevArrow="arrowOption">
                <carousel-arrow dir="left"/>
              </template>
              <template #nextArrow="arrowOption">
                <carousel-arrow dir="right"/>
              </template>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div v-if="isMobileAds" class="has-text-centered">
          <ad :ad-object="secondAd" v-on:ad-loaded="updateAdCounter"></ad>
          <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdCounter"></ad>
        </div>
        <template v-else>
          <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdCounter" class="has-text-centered" v-if="isDesktop"></ad>
          <div v-if="industryRankSorted.length" class="rb__indus-rank">
            <div class="has-text-weight-bold color-blue-dark margin-bottom-24">See how this business has been performing on Hellopeter:</div>
            <rank-in-industries :industries="industryRankSorted"/>
          </div>
          <ad :ad-object="fifthAd" v-on:ad-loaded="updateAdCounter" class="has-text-centered"></ad>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Loader,
  Ad,
  CarouselArrow,
  RankInIndustries,
  BizPerformance
} from '@/components'
import {ReviewCardV2, BizReviewCard, BizOtherReviewCard} from '@/components/reviewCards'
import {auth, misc, adConfig} from '@/mixins'
import axios from 'axios'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'ReviewDetail',
  props: {
    business: {
      type: String
    },
    permalink: {
      type: String
    }
  },
  mixins: [auth, misc, adConfig],
  components: {
    BizPerformance,
    RankInIndustries,
    BizReviewCard,
    Ad,
    ReviewCardV2,
    Loader,
    VueSlickCarousel,
    BizOtherReviewCard,
    CarouselArrow
  },
  data () {
    return {
      reviewDetail: null,
      fetching_data: false,
      sameBizReviews: {
        reviews: []
      },
      sameIndusReviews: {
        indusName: '',
        indusSlug: '',
        reviews: []
      },
      industryRankSorted: []
    }
  },
  computed: {
    bizname () {
      if (this.reviewDetail !== null) {
        return this.reviewDetail.business_name
      }
      return ""
    },
    meta_title () {
      if (typeof this.reviewDetail !== 'undefined' && this.reviewDetail !== null) {
        if (this.reviewDetail.review_rating >= 4) {
          return `[Happy Customer] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
        } else {
          if (this.reviewDetail.replied) {
            return `[Responded] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
          }
          return `[Unhappy Customer] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
        }
      }
      return ''
    },
    og_title () {
      if (typeof this.reviewDetail !== 'undefined' && this.reviewDetail !== null) {
        if (this.reviewDetail.consumerCompetitions.includes('20k')) {
          return "WIN R20,000 by Giving a Business Their First Hellopeter Review"
        } else {
          return `${this.reviewDetail.author} gave ${this.bizname} ${this.reviewDetail.review_rating} star${this.reviewDetail.review_rating > 1 ? 's' : ''}. Check out the full review...`
        }
      }
      return ''
    },
    meta_description () {
      if (this.reviewDetail !== null && this.reviewDetail.review_rating) {
        return `${this.reviewDetail.author} - ` + this.reviewDetail.review_content.replace(/<(?:.|\n)*?>/gm, '').substring(0, 49) + `...`
      }
      return ''
    },
    og_description () {
      if (this.reviewDetail !== null) {
        if (this.reviewDetail.consumerCompetitions.includes('20k')) {
          return "Review a business not yet listed on hellopeter.com, and you could WIN R20,000 cash. 12 months. 12 chances to win. T&CS apply"
        } else if (this.reviewDetail.review_rating) {
          return this.reviewDetail.review_content.replace(/<(?:.|\n)*?>/gm, '').substring(0, 150) + `...`
        }
      }
      return ''
    },
    businessSlug () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.business_slug}`
      }
      return ''
    },
    openGraphBanner () {
      if (this.reviewDetail !== null) {
        //return `${this.reviewDetail.details.og_url}`
        // href: `${window.location.protocol}//${window.location.host}/${this.record.businessDetails.slug}`
        return `${window.location.protocol}//${window.location.host}/reviews/${this.reviewPermalink}`
      }
      return ''
    },
    industryLogo () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.industry_logo}`
      }
      return ''
    },
    reviewPermalink () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.permalink}`
      }
      return ''
    },
    getCanonicalUrl () {
      return [
        {
          rel: 'canonical',
          href: `${window.location.protocol}//${window.location.host}/${this.businessSlug}/reviews/${this.reviewPermalink}`
        }
      ]
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$route !== undefined) {
        this.getReviewDetail()
      }
    }, 100)
    this.loadAds()
  },
  methods: {
    getReviewDetail () {
      this.fetching_data = true
      axios.get(`/consumer/business/${this.business}/reviews/${this.permalink}`)
        .then(({data}) => {
          this.reviewDetail = data

          this.sameBizReviews = data.sameBizReviews
          this.sameIndusReviews = data.sameIndusReviews

          if (data.indusRank.length) {
            data.indusRank.sort((a, b) => a.industryRanking - b.industryRanking);
            this.industryRankSorted = data.indusRank
          }

          /*const xyz = [
            {"industryRanking": 7, "name": "Insurance", "slug": "insurance", "isMainIndus": true},
            {
              "industryRanking": 2,
              "name": "Home Insurance",
              "slug": "home-insurance",
              "isMainIndus": false
            },
            {"industryRanking": 1, "name": "Mobile Insurance", "slug": "mobile-insurance", "isMainIndus": false},
            {
              "industryRanking": 3,
              "name": "Short Term Insurance",
              "slug": "short-term-insurance",
              "isMainIndus": false
            },
            {"industryRanking": 3, "name": "Car Insurance", "slug": "car-insurance", "isMainIndus": false},
          ]
          xyz.sort((a, b) => a.industryRanking - b.industryRanking);
          this.industryRankSorted = xyz*/

          /*this.sameBizReviews = {
            "bizName": "Cartrack",
            "reviews": [{
              "author": {"name": "Ziyanda Q", "reviewsCount": 23, "activeSince": "2023-05-12T07:38:25+02:00", "id": "f5730ff0-f086-11ed-b8c9-65f028f3a2e3"},
              "rating": 1,
              "createdOn": "2023-09-29T15:21:21+02:00",
              "title": "Reverse payment of R6700",
              "body": "Good day can tymebank reverse money R6700 back to the sender then close my account for good \nI don't have interest 😕 anymore of banking with them"
            }, {
              "author": {"name": "Micaela B", "reviewsCount": 2, "activeSince": "2023-07-22T12:25:49+02:00", "id": "095dc870-287a-11ee-8b50-83e0fdc72577"},
              "rating": 1,
              "createdOn": "2023-09-07T19:07:35+02:00",
              "title": "TymeBank BLOCKED ACCOUNT",
              "body": "I’m very disappointed in TymeBank. My account is on hold for a few months now and I’ve tried numerous attempts to contact them everytime they say they will call me back but the issue doesn’t get resolved. They called me back only one time to solve the issue but nothing. I called them and requested a call back again they said they will contact me during the week,mind you it’s been a month now waiting for that call. Everytime I call they redirect me to different departments. This is very unprofessional and unpleasant. I want my account unblocked and my money back. This is uncalled for I am truly fed up of everything. I even submitted an affidavit stating everything. They need to unblock my account I want my money from them!"
            }, {
              "author": {"name": "Samkelisiwe M", "reviewsCount": 3, "activeSince": "2023-07-07T15:46:45+02:00", "id": "e76996c0-1ccb-11ee-ad5a-5103ec6b8713"},
              "rating": 1,
              "createdOn": "2023-07-29T22:29:48+02:00",
              "title": "TymeBank",
              "body": "Hellopeter.  TymeBank put my account on hold since 07 July 2023. I emailed every documents they need bt still no update , it still on hold. Please help"
            }, {
              "author": {"name": "Nomkhosi Z", "reviewsCount": 3, "activeSince": "2023-06-13T14:47:52+02:00", "id": "603dd3a0-09e8-11ee-ae15-5d9417bf50ca"},
              "rating": 1,
              "createdOn": "2023-06-24T14:26:42+02:00",
              "title": "Tymebank acc was blocked",
              "body": "My account was blocked on my I go there n sand everything but no help e Ven you I write every day u just read no help plz help"
            }, {
              "author": {"name": "LUCRICIA M", "reviewsCount": 27, "activeSince": "2022-2:00", "id": "9aadb300-0a68-11ed-b0e4-afa6d3168cf8"},
              "rating": 1,
              "createdOn": "2022-09-000",
              "title": "Account blocked without my knowledge",
              "body": "8902080421083\nNomvelo witness Dube\n0 73 252 1735\n\nAccount blocked without contacting me and without my knowledge I don't understand why tymbank can do such thing.."
            }, {
              "author": {"name": "Vhutshilo M", "reviewsCount": 7, "activeSince": "2018-09-1:00", "id": "1515ee20-b51a-11e8-82ec-75875950500c"},
              "rating": 1,
              "createdOn": "2022-08-00",
              "title": "Fraud case",
              "body": "I was hijacked and robbed on the 8th if August 2022, the criminals took everything u had including my phone and bank card.fortunately enough I managed to call the tymebank  customer care before the money was withdrawn, however the consultant only blocked the card and the criminals transferred R6900 from my account. I called tymbank fraud department and they investigated further, on the 16th August 2022 I received a call from them to inform me that I will be refunded, I been waiting for refund since Monday and I been calling them everyday but told that I will get my refund the next day, it's been 4 days of waiting for a refund now and I'm taken from one department to another. Please help . My contact is 0762687475."
            }, {
              "author": {"name": "Linda M", "reviewsCount": 14, "activeSince": "2022-08-10T12:05:29+02:00", "id": "eb4a30d0-1893-11ed-be5e-c369e17c1589"},
              "rating": 3,
              "createdOn": "2022-08-12T09:45:40+02:00",
              "title": "Test",
              "body": "Test"
            }, {
              "author": {"name": "Mvelo", "reviewsCount": 2, "activeSince": "2021-10-22T12:57:58+02:00", "id": "eaf9fff0-3326-11ec-9ced-ade99d570a66"},
              "rating": 5,
              "createdOn": "2021-10-22T12:59:35+02:00",
              "title": "It's helpful",
              "body": "It's helpful"
            }, {
              "author": {"name": "Moroke M", "reviewsCount": 21, "activeSince": "2017-10-25T15:38:20+02:00", "id": "319202aa-31fa-11e8-83f4-f23c91bb6188"},
              "rating": 2,
              "createdOn": "2021-09-28T16:24:02+02:00",
              "title": "Wealth Today",
              "body": "Good day, I’m still awaiting a response from my query about Wealth Today."
            }]
          }*/

          /*this.sameIndusReviews = {
            "indusName": "Security",
            "indusSlug": "security",
            "reviews": [{
              "business_logo": null,
              "business_name": "Eskom",
              "industry_name": "Governments & Ombudsman",
              "review_rating": "1",
              "authorDisplayName": "Johannes N",
              "created_at": "2023-07-11T15:57:27+02:00",
              "review_title": "Eskom zone 15 Garankuwa industrial",
              "review_content": "I'm very sad about the services we get from eskom,we started to report electric box from this dates 25 May 2023...07 June 2023...04 July 2023...06 July 2023 nothing has been resolved Ref:6788344442 this box trap all the time.we need new box why is so difficult to replace it ...I'm afraid it will burn the house one day,I'm very disappointed 😞",
              "business_slug": "eskom",
              "permalink": "https://staging.hellopeter.com/business/eskom/reviews/eskom-zone-15-garankuwa-industrial-4507881"
            }, {
              "business_logo": null,
              "business_name": "postaboy trading",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Sandi M",
              "created_at": "2023-07-11T12:22:12+02:00",
              "review_title": "UNAUTHORIZED CREDIT CHECK",
              "review_content": "UNAUTHORIZED CREDIT CHECK\nThis company did a credit check without my consent and it appears on my credit report. Thats affecting my credit score. 😡\n\n I have a case opened at the Sandton police station - Gauteng for tamie mthembu who is the CEO of postaboy trading. they are also trading under a logistics company called LQZ unlimited holding. Let's find this guy and let the law take its course. The company was renting officespace at Regal Durben.",
              "business_slug": "postaboy-trading",
              "permalink": "https://staging.hellopeter.com/business/postaboy-trading/reviews/unauthorized-credit-check-232028c48df782c2a2d84f78772f7f6cebdbab70-4507200"
            }, {
              "business_logo": null,
              "business_name": "TeleDialCom",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Izaan",
              "created_at": "2023-07-11T11:51:05+02:00",
              "review_title": "TELEDIALKOM ARE ****MERS!!!!",
              "review_content": "DO NOT PAY THEM! DO NOT ENGAGE WITH THEM. \n\nThey are HUGE **** artists.  Been going on for years. \n\nThey will first tell you they just want to update your listing. \nNext minute you owe them thousands.",
              "business_slug": "teledialcom",
              "permalink": "https://staging.hellopeter.com/business/teledialcom/reviews/teledialkom-are-mers-4507107"
            }, {
              "business_logo": null,
              "business_name": "Brotel",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Craig W",
              "created_at": "2023-07-11T10:37:01+02:00",
              "review_title": "Brotel - ****mers",
              "review_content": "**** brokers into thinking they're buying qualified leads when in fact Brotel *****s the money and then vanishes.\n\nSharon Leonard heads up the **** - 076 977 2508",
              "business_slug": "brotel",
              "permalink": "https://staging.hellopeter.com/business/brotel/reviews/brotel-mers-4506830"
            }, {
              "business_logo": null,
              "business_name": "basicloves.com",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Carl",
              "created_at": "2023-07-11T10:36:33+02:00",
              "review_title": "https://basicloves.com/ ****mers",
              "review_content": "They are a ****. The offered a small electric device that I bought. It was never delivered.\nThe next month they used my card number to deduct a fee from my card. Suddenly I \"agreed\" last time to receive their ads and \"agreed\" to pay this fee to get it.\nThey are *****sters and ****mers.\nAlthough they have a .com website they advertise from the UK.",
              "business_slug": "httpsbasiclovescom",
              "permalink": "https://staging.hellopeter.com/business/httpsbasiclovescom/reviews/httpsbasiclovescom-mers-4506828"
            }, {
              "business_logo": null,
              "business_name": "NISSAN  GROUP 1",
              "industry_name": "Business Services",
              "review_rating": "5",
              "authorDisplayName": "nozukom M",
              "created_at": "2023-07-10T11:09:45+02:00",
              "review_title": "Nozukom",
              "review_content": "I purchased a vehicle Ford focus in February,a day after a light for sensor was on and i informed them.the tires at back are finished. The licence disk of the vehicle has expired. I had to service the vehicle myself and i paid for road worthy. I never received paperwork for the vehicle. They provided a bad service bacause im a women",
              "business_slug": "nissan-group-1",
              "permalink": "https://staging.hellopeter.com/business/nissan-group-1/reviews/nozukom-4505071"
            }, {
              "business_logo": null,
              "business_name": "Hyperli.com",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Angelo D",
              "created_at": "2023-07-10T09:13:04+02:00",
              "review_title": "SHAME ON YOU HYPERLI HOW YOU'VE FALLEN!!!",
              "review_content": "If only I had checked Hellopeter first, but I trusted Hyperli as I've purchased vouchers before and even recommended Hyperli to family and friends.\nI placed an order on 3 July and to date have not received any form of correspondence from them and no response to my email, and their telephone number doesn't seem to exist either.\nI now have to speak to family and friends again to warn them to stay away.!!! The trust is broken and I suppose my hard earned money is lost.\nSHAME ON YOU HYPERLI, HOW YOU'VE FALLEN!!!",
              "business_slug": "hyperlicom",
              "permalink": "https://staging.hellopeter.com/business/hyperlicom/reviews/shame-on-you-hyperli-how-youve-fallen-4504727"
            }, {
              "business_logo": null,
              "business_name": "Eazy ads",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "motsomi 0835661370",
              "created_at": "2023-07-10T08:45:40+02:00",
              "review_title": "Easy ads ****",
              "review_content": "I received calls from Kevin offering advertising services. I checked his references about the integrity of Kevin services which gave positive feedback and continued to pay Kevin who insisted he wanted immediate clearance. To date no ads and no refund. What a **** and *****sters who took my money. Police must investigate this guy",
              "business_slug": "eazy-ads",
              "permalink": "https://staging.hellopeter.com/business/eazy-ads/reviews/easy-ads-4504658"
            }, {
              "business_logo": null,
              "business_name": "Bargin Shop Dress For Less",
              "industry_name": "Business Services",
              "review_rating": "1",
              "authorDisplayName": "Dede C",
              "created_at": "2023-07-08T19:20:59+02:00",
              "review_title": "Big ****MERS -  Bargin Shop dress for less",
              "review_content": "Bought a pair of shoes online at the Bargin Shop  Dress for Less. It never came. They first emailed me that there was a delay in shipment when I questioned them on merchandise that I purchased a month ago. After I emailed them a 2n and 3rd time they never rep**** again. Obviously a big rotten ****😤😫",
              "business_slug": "bargin-shop-dress-for-less",
              "permalink": "https://staging.hellopeter.com/business/bargin-shop-dress-for-less/reviews/big-mers-bargin-shop-dress-for-less-4504035"
            }]
          }*/

          this.fetching_data = false

          const brandName = data.business_name !== 'undefined' ? data.business_name : ''
          const industryName = data.industry_name !== 'undefined' ? data.industry_name : ''
          this.$gtm.trackEvent({
            event: 'pageLoad',
            virtualPageUrl: this.$router.currentRoute.path,
            virtualPageTitle: this.meta_title,
            brandName: brandName,
            industryName: industryName
          })
          window.prerenderReady = true
          googletag.cmd.push(() => {
            googletag.pubads().setTargeting('Pagetype', this._routeName)
            googletag.pubads().setTargeting('URL', window.location.href)
            if (data.nps_rating !== null) {
              let happyText = 'Unhappy customer'
              if (data.nps_rating === 7 || data.nps_rating === 8) {
                happyText = 'Undecided customer'
              } else if (data.nps_rating === 9 || data.nps_rating === 10) {
                happyText = 'Happy customer'
              }
              googletag.pubads().setTargeting('Customer Type', happyText)
            }
            googletag.pubads().setTargeting('Stars', data.reviewRating)
            googletag.pubads().setTargeting('Brand', data.business_name)
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
          })
        })
        .catch((error) => {
          if (typeof error !== 'undefined' && typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined') {
            if (error.response.status === 404) {
              window.location.href = '/404'
            } else {
              console.log('stringify error', JSON.stringify(error))
            }
          }
        })
    }
  },
  metaInfo () {
    return {
      title: this.meta_title,
      titleTemplate: '%s on Hellopeter.com',
      meta: [
        {name: 'description', content: this.meta_description},

        {'property': 'og:type', 'content': 'website'},
        {'property': 'og:description', 'content': this.og_description},
        {'property': 'og:image', 'content': 'https://www.hellopeter.com/static/img/logo/hp-fb-crawl-3.png'},
        //{'property': 'og:image', 'content': (encodeURI(this.openGraphBanner) ? encodeURI(this.openGraphBanner) : this.industryLogo)},
        // {'property': 'og:image', 'content': (encodeURI(this.businessLogo) ? encodeURI(this.businessLogo) : this.industryLogo)},
        {'property': 'og:title', 'content': this.og_title},
        {'property': 'og:url', 'content': `${window.location.protocol}//${window.location.host}/${this.businessSlug}/reviews/${this.reviewPermalink}`},

        {'property': 'fb:app_id', 'content': process.env.FACEBOOK_APP_ID}
      ],
      link: this.getCanonicalUrl,
      bodyAttrs: {
        class: 'review'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.page-content {
  max-width: 1354px;
  margin-left: auto;
  margin-right: auto;
  padding: 32px 20px 0 99px;
  color: map-get($colors, 'gray');

  @include not-desktop {
    padding-left: 0;
    padding-right: 0;
    padding-top: 21px;
  }

  .separator {
    margin-top: 54px;
    margin-bottom: 33px;

    @include tablet {
      margin-top: 29px;
    }

    @include mobile {
      margin-top: 23px;
      margin-bottom: 20px;
    }
  }
}

.left-box {
  max-width: calc(100% - 442px);

  @include not-desktop {
    max-width: 100%;
  }

  @include tablet {
    padding-left: 40px;
    padding-right: 31px;
  }

  @include mobile {
    padding-left: 10px;
    padding-right: 10px;
  }

  .biz-perf {
    @include tablet {
      margin-left: 23px;
      margin-top: 28px;
    }

    @include mobile {
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 18px;
    }

    > > > .perf-card {
      @include tablet {
        width: 225px;
        margin-bottom: 0;
      }

      @include mobile {
        font-size: 8.5px;
        padding-left: 10px;
        padding-top: 3px;
        height: 23px;
        margin-bottom: 0;

        .perf-card__head {
          font-size: 10px;
          width: 47px;
        }

        .tooltip-icon {
          width: 10px;
          height: 10px;
          font-size: 7px;
        }
      }
    }
  }

  .lb_head {
    @include tablet {
      margin-left: 26px;
    }

    @include mobile {
      font-size: 12px;
      margin-left: 15px;
    }
  }

  > > > .slick-slider {
    margin-left: -9px;
    margin-right: -6px;

    @include tablet {
      margin-left: -47px;
      margin-right: -31px;
    }

    @include mobile {
      margin-left: -14px;
      margin-right: -5px;
    }

    .slick-list {
      @include tablet {
        padding: 0 37px;
      }

      @include mobile {
        padding: 0 18px;
      }
    }

    .slick-slide {
      width: 272px;
      padding-left: 8.5px;
      padding-right: 8.5px;

      @include tablet {
        width: 237px;
        padding-left: 7px;
        padding-right: 7px;
      }

      @include mobile {
        width: 287px;
        padding-left: 3.5px;
        padding-right: 3.5px;
      }
    }
  }

  .custom-arrow {
    width: 10px;

    img {
      position: absolute;
      top: 0
    }
  }

  .custom-arrow.slick-prev {
    left: -8px;
  }

  .custom-arrow.slick-next {
    right: -16px;
  }
}

.right-box {
  width: 400px;
  margin-left: 42px;
  padding: 10px 34px 10px 33px;
  background-color: #f6f6f6;
  border-radius: 2px;

  @include not-desktop {
    width: 100%;
    margin-left: 0;
  }

  @include tablet {
    display: flex;
    padding: 0 0 0 51px;

    .rb__indus-rank {
      width: 300px;
      margin-top: 21px;
      margin-bottom: 24px;

      #rankingWidget {
        font-size: 14px;
        box-shadow: none;
        padding-bottom: 12px;

        > > > {
          h4 {
            color: map-get($colors, 'gray');
          }

          .separator {
            display: none;

            ~ div .font-size-12 {
              font-size: 14px;

              .link--v2 {
                margin-left: 0;
              }
            }
          }
        }

      }
    }
  }

  @include mobile {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reviews/ReviewDetail.vue